import type { ExternalSiteCheckRule } from "../../types";
import { SHOPBY_PAGE, SITE_TYPE } from "./const";

const isShopByHomePath = (pathname: string) => {
  const result = [
    "/",
    "/#",
    "/index",
    "/index.html",
    "/index#",
    "/index.html#",
  ].some((path) => {
    return path === pathname;
  });
  return result;
};

const shopby: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target }) {
    const urlSearchParams = url.pathname + url.search;

    if (target.value === "HOME" && isShopByHomePath(url.pathname)) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.LOGIN.target &&
      url.pathname === SHOPBY_PAGE.LOGIN.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.MY_PAGE.target &&
      url.pathname === SHOPBY_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.SIGNUP.target &&
      url.pathname === SHOPBY_PAGE.SIGNUP.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.FIND_ID.target &&
      url.pathname === SHOPBY_PAGE.FIND_ID.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.FIND_PASSWORD.target &&
      url.pathname === SHOPBY_PAGE.FIND_PASSWORD.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.CART.target &&
      url.pathname === SHOPBY_PAGE.CART.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.POLICY.target &&
      url.pathname === SHOPBY_PAGE.POLICY.url
    ) {
      return true;
    }

    if (
      target.value === SHOPBY_PAGE.PRIVACY.target &&
      url.pathname === SHOPBY_PAGE.PRIVACY.url
    ) {
      return true;
    }

    if (target.value === SHOPBY_PAGE.PRODUCT_DETAIL.target) {
      const conditionPathname = target.params?.productSlug
        ? `${SHOPBY_PAGE.PRODUCT_DETAIL.url}?${target.params.productSlug}`
        : `${SHOPBY_PAGE.PRODUCT_DETAIL.url}`;
      if (urlSearchParams.startsWith(conditionPathname)) {
        return true;
      }
    }

    return false;
  },
};

export default shopby;
